import 'components/sessions/registration-form/registration-form';
import 'components/sessions/join-newsletter/join-newsletter';

import RecaptchaController from 'components/util/recaptcha/recaptcha-controller';

window.EezyStimulusApplication.register('recaptcha', RecaptchaController);
